import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadAdsCampaign } from '@tinct/core-api-models';
import { ApiCollectionResponse } from '../../types';
import { ApiError, tinctApi } from '../../api';
import { GetAdsCampaignsParams } from '../../endpoints/crm-integrations';

export const getAdsCampaigns = async (
  params: GetAdsCampaignsParams,
): Promise<ApiCollectionResponse<ReadAdsCampaign>> => {
  return await tinctApi.crmIntegrations.getAdsCampaigns(params);
};

export const useGetAdsCampaigns = (
  params: GetAdsCampaignsParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadAdsCampaign>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['ads-campaigns', params.integrationId, params],
    queryFn: () => getAdsCampaigns(params),
    ...options,
  });
